import React, {useState, useEffect} from 'react'
import Settings from "../../../services/settings";
import Storage from "../../../services/storage.service";
import {readableStorage} from "../../../services/helpers";
import {userHasDeviceByDeliveryType} from "../../../services/vip.bundle.service";
import Translations from "../../../services/translation";
import EditDevicePopup from "../../Plans/PhoneDeviceAddOn/EditDevicePopup";
import {isZaamEnabled} from "../../../services/instalments.service";
import PaymentCardsWithZaam from "../../Instalments/Zaam/PaymentCardsWithZaam";

export const SummaryDeviceBox = ({
  savedPlan,
  disableDeviceEdit,
  showPaymentOptions,
  subscribeToZaam,
  subscribed
}) => {
  const strings = Translations["keys"][Translations.activeLang];

  const [showEditPopup, setShowEditPopup] = useState(false);
  const [planHasDevice, setPlanHasDevice] = useState();

  useEffect(()=> {
    if(savedPlan){
      let devicePlan = userHasDeviceByDeliveryType(savedPlan);
      setPlanHasDevice(devicePlan);
      if(!devicePlan && subscribed){
        subscribeToZaam(false);
      }
    }
  }, [savedPlan, subscribed, subscribeToZaam]);


  let device_spec, device_name, capacity, device_color, device_img_path="";
    if(planHasDevice){
      device_spec = savedPlan?.Plans?.find(p=> !Settings.types.includes(p.Type))
      if (device_spec){
        device_name = device_spec.ExtraDetails?.Name;
        device_color = device_spec.ExtraDetails?.Colour;
        let capacityInBytes = device_spec.ExtraDetails?.Capacity;
        capacity = capacityInBytes ? readableStorage(capacityInBytes): ''
        let imgArr = device_spec.ExtraDetails?.images;
        let root_path = device_spec.ExtraDetails?.imagesRootPath;
        if (root_path && imgArr){
          device_img_path = `${root_path}${imgArr.split(",")[0]}`
        } 
      }
    }
  
  return !planHasDevice ? '' : (
    <>
    <div className="vmo-summary-section map-summary-section">
      <div className="vmo-summary-box-wrapper">
        <div className="vmo-summary-box">
          <div className="vmo-summary-section-header">
            <div className="summary-device-specs" key="device">
              <div className="vmo-summary-section-header">
                  <h3>{strings['SUMMARY_PLAN_SPECS_DEVICE_TITLE']}</h3>
                  {disableDeviceEdit?'':
                  <div className="vmo-summary-edit" 
                  onClick={() => {
                    let isMobile = window.screen.width < 1001;
                    if(isMobile){
                      Storage.set("showiPhoneEditModalOnMobile", true);
                    }else{
                      setShowEditPopup(true)
                    }
                  }}
                  />}
              </div>
              <div  className={"vmo-plan-spec vmo-plan-spec-device"}>
                <span className="vmo-plan-spec-value">
                  <p className="vmo-plan-spec-device-name">{device_name}</p>
                  <p className="vmo-plan-spec-device-details">{`${capacity} - ${device_color}`}</p>
                  <div className="specs-bundle-device-img-wrapper">
                    <img className="vmo-plan-spec-device-img" src={device_img_path} alt=""/>
                  </div>
                </span>
              </div>
              {showPaymentOptions && isZaamEnabled() && <PaymentCardsWithZaam 
                subscribeToZaam={subscribeToZaam}
                subscribed={subscribed}
                savedPlan={savedPlan} 
                sku={device_spec?.ExtraDetails?.SKU}
              />}
            </div>
          </div>
        </div>
      </div>
    </div>
    {showEditPopup && <EditDevicePopup close={() => setShowEditPopup(false)}/>}
    </>
  )
}

export default SummaryDeviceBox;